import Api from '../../../services/api/mini-calculators/multipliers';

const mutationTypes = {
    UPDATE_VALUE: 'UPDATE_VALUE',
    RESET_VALUES: 'RESET_VALUES',
};

// Initial State
const state = {
    ogdenTableInfo: [],
    ogdenTable: null,
    multiplier: 0,
    discountRate: '-0.25',
    dateOfBirth: null,
    dateOfTrial: null,
    ageAtTrial: null,
    term: null,
    tableData: null,
};

// Getters
const getters = {
    findValue: state => key => state[key],
};

// Actions
const actions = {
    loadOgdenTableInfo({commit}) {
        Api.ogdenTableInfo()
            .then((updated) => {
                commit(mutationTypes.UPDATE_VALUE, {key: 'ogdenTableInfo', value: updated});
            });
    },
    updateValue({commit}, {key, value}) {
        commit(mutationTypes.UPDATE_VALUE, {key, value});
    },
    calculateMultiplier({state, commit}) {
        if (state.ogdenTable.length < 7 || state.discountRate === null || state.term === '') {
            return;
        }

        let table = state.ogdenTable.slice(6);
        if (table < 1 || table > 28 || table === '27') {
            return;
        }

        Api.lookupOgdenMultiplier(
            {
                table: table,
                col: state.discountRate,
                row: table === '28' ? state.term : state.ageAtTrial
            }
        ).then((data) => {
            commit(mutationTypes.UPDATE_VALUE, {key: 'multiplier', value: data.multiplier});
            commit(mutationTypes.UPDATE_VALUE, {key: 'tableData', value: data.tableData});
        });
    },
    resetValues({commit}) {
        commit(mutationTypes.RESET_VALUES);
    },
};

// Mutations
const mutations = {
    [mutationTypes.UPDATE_VALUE](state, payload) {
        state[payload.key] = payload.value;
    },
    [mutationTypes.RESET_VALUES](state) {
        state.ogdenTableInfo = [];
        state.ogdenTable = null;
        state.multiplier = 0;
        state.discountRate = '-0.25';
        state.dateOfBirth = null;
        state.dateOfTrial = null;
        state.ageAtTrial = null;
        state.term = null;
        state.tableData = null;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/mini/interpolatedMultipliers.js